module.exports = __webpack_public_path__ + "static/media/broccoli.7f0ca851.jpg";